import React from "react";
import FooterV2 from "./FooterV2";
import IGFeed from "./IGFeed";
import "../../Components/Footer/footer.css";

const FooterContainer = () => {
  return (
    <>
      {/* <div id="page-break">
        <h4>
          <a
            href="http://instagram.com/tederlive"
            target="blank"
            className="follow-us"
          >
            FOLLOW US @ONTEDER
          </a>
        </h4>
      </div>
      <div id="ig-feed">
        <IGFeed />
      </div> */}
      <div id="footer">
        <FooterV2 />
      </div>
    </>
  );
};

export default FooterContainer;
